module.exports = __webpack_public_path__ + "img/premios-mujer-de-valor.6a4cc332.jpg";